import React, { useState } from 'react'
import { MdEmail } from 'react-icons/md'
import EmailModal from '../CreateSegment/EmailModal/EmailModal'
import styles from './EmailSender.module.scss'
import { useLocation } from 'react-router-dom'
import { useAliasNodePage } from 'modules/website/hooks/useAliasNodePage'
import { PulseLoader } from 'react-spinners'
import { useMailTitle } from 'modules/website/hooks/useMailTitle'

export default function EmailSender(props) {
    const { titlePage, secondstyle } = props
    const [showModalEmail, setShowModalEmail] = useState(false);
    const location = useLocation();
    let alias = location.pathname.replace('/', '');
    if(alias === '') alias = 'Home';
    //console.log(alias);
    if (alias.includes('/')) {
        alias = alias.replace(/\//g, "$$");
    }
    if (alias.includes('$')) {
        alias = alias.replace("$", "$$");
    }
    //console.log(JSON.stringify(alias));
    const { isLoading, isError, payload, error } = useMailTitle({
        alias: alias,
    });

    //console.log(payload);

    if (isLoading) return (
        <div className={`${styles.btnloading}`}>
            <PulseLoader
                loading={true}
                size={5}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
    if (!isError && payload && !isLoading) {
        return (
            <div>

                <button
                    onClick={() => setShowModalEmail(true)}
                    className={`btn ${secondstyle ? styles.btnSecond: styles.iconButton}`}
                >
                    <MdEmail className={styles.icon} />
                    <span className={styles.icons_label}>E-mail</span>
                </button>
                <EmailModal
                    show={showModalEmail}
                    handleClose={() => setShowModalEmail(false)}
                    titleName={payload.title[0].value}
                />
            </div>
        )
    }
}
